/* global axios */
// Configurações › Integrações › Asaas | Tramitação Inteligente (09/10/2026).
import ApiClient from './ApiClient';

class IntegracoesDoEscritorioAPI extends ApiClient {
  constructor() {
    super('integracoes-do-escritorio', { accountScoped: true });
  }

  retrato(fornecedor) {
    return axios.get(`${this.url}/${fornecedor}`);
  }

  salvar(fornecedor, integracao) {
    return axios.patch(`${this.url}/${fornecedor}`, { integracao });
  }

  testar(fornecedor) {
    return axios.post(`${this.url}/${fornecedor}/testar`);
  }

  conectarAvisos(fornecedor) {
    return axios.post(`${this.url}/${fornecedor}/conectar-avisos`);
  }

  // Asaas: cola a chave e conecta em um gesto (confere, grava, liga, avisos).
  conectar(fornecedor, chave) {
    return axios.post(`${this.url}/${fornecedor}/conectar`, { chave });
  }
}

export default new IntegracoesDoEscritorioAPI();
